/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _typeof = _interopDefault(require('babel-runtime/helpers/typeof'));
var mergeDescriptors = _interopDefault(require('merge-descriptors'));

/**
 * @param {...Object} args
 * @returns {Object}
 */
function multiMergeDescriptors() {
  var redefine = void 0;

  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (_typeof(args[args.length - 1]) !== 'object') {
    redefine = args.pop();
  }

  return args.slice(1).reduce(function (dest, src, i) {
    return mergeDescriptors(dest, src, redefine);
  }, args[0]);
}

module.exports = multiMergeDescriptors;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/util/multi-merge-descriptors.js
// module id = 25
// module chunks = 1